import { ReactNode } from "react";

import {
  mobileFullWidthCss,
  sectionContainerCss,
  sectionTitleCss,
  unorderedListCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection/PopoutMenuSection.styles";

const PopoutMenuSection = ({ title, children, width }: IPopoutMenuSection) => {
  return (
    <div
      css={[sectionContainerCss, { width }, mobileFullWidthCss]}
      data-testid="popout-menu-section"
    >
      {title && <h2 css={sectionTitleCss}>{title}</h2>}

      <ul css={unorderedListCss}>{children}</ul>
    </div>
  );
};

interface IPopoutMenuSection {
  title?: string;
  width?: string;
  children: ReactNode;
}

PopoutMenuSection.displayName = "PopoutMenuSection";
export { PopoutMenuSection };
